import React from "react";
import { Link } from "react-router-dom";
import { Car, ArrowLeft } from "lucide-react";

const PoliticaCookies = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-100 py-4">
        <div className="max-w-4xl mx-auto px-4 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2" data-testid="cookies-logo">
            <div className="w-10 h-10 bg-emerald-500 rounded-xl flex items-center justify-center">
              <Car className="w-6 h-6 text-white" />
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-lg text-gray-900 leading-tight">AUTO PRO</span>
              <span className="text-xs text-emerald-600 font-medium -mt-1">DAUNE</span>
            </div>
          </Link>
          <Link to="/" className="ml-auto flex items-center gap-1 text-sm text-gray-500 hover:text-emerald-600" data-testid="cookies-back">
            <ArrowLeft className="w-4 h-4" />Inapoi
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12" data-testid="cookies-page">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Politica de Cookies</h1>
        <p className="text-sm text-gray-400 mb-8">Ultima actualizare: Aprilie 2026</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">1. Ce sunt cookie-urile?</h2>
            <p>Cookie-urile sunt mici fisiere text stocate pe dispozitivul dumneavoastra de catre browser-ul web atunci cand vizitati un site. Acestea permit site-ului sa va recunoasca si sa retina informatii despre vizita dumneavoastra.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">2. Ce cookie-uri folosim?</h2>
            
            <h3 className="text-lg font-semibold text-gray-800 mt-4 mb-2">a) Cookie-uri strict necesare (tehnice)</h3>
            <p>Aceste cookie-uri sunt esentiale pentru functionarea site-ului si nu pot fi dezactivate:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Sesiune de autentificare:</strong> Pastreaza datele de login pentru portalul de afiliati si admin</li>
              <li><strong>Preferinte cookie:</strong> Retine alegerea dumneavoastra privind acceptarea cookie-urilor</li>
            </ul>

            <h3 className="text-lg font-semibold text-gray-800 mt-4 mb-2">b) Cookie-uri analitice</h3>
            <p>Aceste cookie-uri ne ajuta sa intelegem cum este utilizat site-ul:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>PostHog Analytics:</strong> Colecteaza date anonime despre vizitele pe site pentru a imbunatati experienta utilizatorilor</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">3. Durata cookie-urilor</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Cookie-uri de sesiune:</strong> Se sterg automat la inchiderea browser-ului</li>
              <li><strong>Cookie-uri persistente:</strong> Raman pe dispozitiv pana la expirare (max. 12 luni) sau pana le stergeti manual</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">4. Cum puteti controla cookie-urile?</h2>
            <p>Puteti controla si sterge cookie-urile prin setarile browser-ului dumneavoastra:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Chrome:</strong> Setari &gt; Confidentialitate si securitate &gt; Cookie-uri</li>
              <li><strong>Firefox:</strong> Setari &gt; Confidentialitate &gt; Cookie-uri</li>
              <li><strong>Safari:</strong> Preferinte &gt; Confidentialitate &gt; Cookie-uri</li>
              <li><strong>Edge:</strong> Setari &gt; Cookie-uri si permisiuni pentru site-uri</li>
            </ul>
            <p className="mt-2"><strong>Atentie:</strong> Dezactivarea cookie-urilor tehnice poate afecta functionarea corecta a site-ului.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">5. Actualizari</h2>
            <p>Ne rezervam dreptul de a actualiza aceasta politica. Orice modificare va fi publicata pe aceasta pagina cu data actualizarii.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">6. Contact</h2>
            <p>Pentru intrebari despre cookie-uri: <strong>office@autoprodaune.ro</strong></p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default PoliticaCookies;
